const getNonFoodDeliveryInfo = (entries: any[] = []) =>
  ((entries[0] || {}).product || {}).deliveryTimeDescription || '2-4 Business Days';

export const getNonFoodOrderDeliveryInfo = (entries: any[] = []) => {
  const [{ orderEntry }] = entries;
  return (orderEntry.product || {}).deliveryTimeDescription || '2 - 4 Business Days';
};

export default getNonFoodDeliveryInfo;
